import { createAction, props } from '@ngrx/store';

export const setViewVisible = createAction(
	'[Vehicle List View] Set View Visible',
	props<{ viewVisible: boolean }>()
);
